import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import { IconButton, Tooltip } from "@mui/material";
import {
  LocalGasStationOutlined as FuelIcon,
  PaymentOutlined as PaymentIcon,
  ReceiptLongOutlined as ReceiptIcon,
  BuildOutlined as RepairIcon,
  Edit as IconEdit,
  LocalPrintshop as IconPrint,
} from "@mui/icons-material";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import ChkBox from "components/Custom/ChkBox";
import TxtBox from "components/Custom/TxtBox";
import FuelForm from "../Fuel/FuelForm";
import TripPaymentForm from "../TripPayment/TripPaymentForm";
import TripReceiptForm from "../TripReceipt/TripReceiptForm";
import RepairForm from "../Repair/RepairForm";

import { NOTIFY, DEFAULTS, FORMATS } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { COMMON_JS } from "common/scripts";
import { DateFunctions } from "common/datefunctions";
import { REEFER, GOPAL_SNACKS, PARCEL } from "common/config";

import { ApiMasters } from "apihandlers//masters/masters";
import { ApiIndents } from "apihandlers//indent";
import { ApiGeography } from "apihandlers//geography";

import "./styles/users.css";

const ApiMastersHandler = new ApiMasters();
const ApiIndentHandler = new ApiIndents();
const ApiGeographyHandler = new ApiGeography();

const Trips = (props: any) => {
  const { setDashMenu } = props;

  const tempIdRef: any = useRef();
  const loadingPointIdRef: any = useRef();
  const unloadingPointIdRef: any = useRef();
  const vehicleIdRef: any = useRef();
  const customerIdRef: any = useRef();
  const brokerIdRef: any = useRef();
  const driversRef: any = useRef();
  const drivers2Ref: any = useRef();

  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [loadingPoints, setLoadingPoints] = useState<any>(null);
  const [unLoadingPoints, setUnLoadingPoints] = useState<any>(null);
  const [vehicles, setVehicles] = useState<any>(null);
  const [customers, setCustomers] = useState<any>(null);
  const [tempratures, setTempratures] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [selectedLoadPoints, setSelectedLoadPoints] = useState<any>([]);
  const [selectedUnLoadPoints, setSelectedUnLoadPoints] = useState<any>([]);
  const [driverNames, setDriverNames] = useState<any>([]);
  const [driver2Names, setDriver2Names] = useState<any>([]);
  const [getAllPoints, setGetAllPoints] = useState<boolean>(false);
  const [loadingBtnTitle, setLoadingBtnTitle] = useState<any>(
    LABELS.SHOW_ALL_POINTS
  );
  const [mandatoryResults, setMandatoryResults] = useState<any>({});
  const [fuelEntryDialog, setFuelEntryDialog] = useState<boolean>(false);
  const [paymentEntryDialog, setPaymentEntryDialog] = useState<boolean>(false);
  const [receiptEntryDialog, setReceiptEntryDialog] = useState<boolean>(false);
  const [repairtEntryDialog, setRepairEntryDialog] = useState<boolean>(false);

  useEffect(() => {
    if (loading) {
      getVehicles();
    }
  }, [loading]);

  const getVehicles = () => {
    const args = {
      activeStatus: "true",
      shortMode: true,
    };
    ApiMastersHandler.getVehicles(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.vehicleNumber,
          };
        });
        setVehicles(list);
        getAreas();
      }
    });
  };

  const getAreas = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        // setLoadingPoints(list);
        setUnLoadingPoints(list);
        getCustomers();
      }
    });
  };

  const getCustomers = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTransporters(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.organizationName,
          };
        });
        setCustomers(list);
        getTempRanges();
      }
    });
  };

  const getTempRanges = () => {
    const args = {
      activeStatus: "true",
      minResponse: true,
    };
    ApiMastersHandler.getTempRanges(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.tempName,
          };
        });
        setTempratures(list);
        getDrivers();
      }
    });
  };

  const getDrivers = () => {
    const args = {
      activeStatus: true,
      shortMode: true,
    };
    ApiMastersHandler.getDrivers(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.fullName,
          };
        });
        setDriverNames(list);
        setDriver2Names(list);
        getLoadingPoints();
      }
    });
  };

  const getLoadingPoints = () => {
    const args = {
      activeStatus: "true",
      loadingOnlyStatus: "true",
      minResponse: true,
    };
    ApiGeographyHandler.getAreas(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.areaName,
          };
        });
        setLoadingPoints(list);
        setLoading(false);
        getRows();
      }
    });
  };

  const getRows = async () => {
    const fromDate = (
      document.getElementById("fromDate") as HTMLInputElement
    ).value.trim();
    const toDate = (
      document.getElementById("toDate") as HTMLInputElement
    ).value.trim();
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      fromDate,
      toDate,
    };
    setRows(null);
    const res = await ApiIndentHandler.getTrips(args);
    const response: any = res.response;
    console.log("args:", args);
    const { status } = res;
    if (status === 200) {
      let list = response.records;
      for (let i = 0; i < response.records.length; i++) {
        list[i]["slNo"] = i + 1;
        if (list[i]["activeStatus"]) {
          list[i]["activeStatusText"] = "Yes";
        } else {
          list[i]["activeStatusText"] = "No";
        }
        list[i]["totCrates"] = Number(list[i]["totCrates"]);
      }
      setRows(list);
      setLoading(false);
      console.log("Rows", list);
    }
  };

  const getTripLoadUnloads = (indentId) => {
    const args = { indentId, activeStatus: "true", web: true };
    ApiIndentHandler.getLoadUnloadPoints(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        setSelectedLoadPoints(response.loadPoints);
        setSelectedUnLoadPoints(response.unloadPoints);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    setSelectedLoadPoints(null);
    setSelectedUnLoadPoints(null);
    getTripLoadUnloads(row.id);
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      editable: "false",
      sortable: " true",
      searchable: "true",
      align: "center",
      headerAlign: "center",
      frozen: true,
    },
    {
      key: "indentNo",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_NO,
      width: "15%",
      frozen: true,
    },
    {
      key: "indReceiptDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INDENT_DATE,
      width: "15%",
      frozen: true,
    },
    {
      key: "fromLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FROM,
      width: "12%",
    },
    {
      key: "toLoc",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TO,
      width: "12%",
    },
    {
      key: "freight",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FRIGHT,
      width: "10%",
    },
    {
      key: "totCrates",
      name: LABELS.ORDERED_QTY,
      type: "number",
      width: "7%",
      sortable: true,
      searchable: true,
    },
    {
      key: "crateCapacity",
      name: LABELS.CRATE_CAPACITY,
      type: "number",
      width: "7%",
      sortable: true,
      searchable: true,
    },
    {
      key: "vehicleNo",
      name: LABELS.VEHICLE_NO,
      type: "text",
      width: "10%",
      sortable: true,
      searchable: true,
      editable: false,
    },
    {
      key: "driverName",
      name: LABELS.DRIVER_NAME,
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      width: "10%",
    },
    {
      key: "driverBalance",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_BALANCE,
      width: "10%",
    },
    {
      key: "expectedTime",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EXPECTED_TIME,
      width: "5%",
    },
    {
      key: "actualTime",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTUAL_TIME,
      width: "5%",
    },
    {
      key: "expectedKM",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EXPECTED_KM,
      width: "5%",
    },
    {
      key: "actualKM",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTUAL_KM,
      width: "5%",
    },
    {
      key: "weight",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.NET_WT,
      width: "5%",
    },
    {
      key: "maxPassingTon",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PASSING_TON,
      width: "5%",
    },
    // { key: "indentGroup", name: LABELS.GROUP, width: "10%" },
    {
      key: "referenceNo",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.REFERENCE,
      width: "10%",
    },
    {
      key: "status",
      type: "dropdown",
      filters: [
        {
          id: "created",
          name: "CREATED",
        },
        {
          id: "assigned",
          name: "ASSIGNED",
        },
        {
          id: "completed",
          name: "COMPLETED",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.STATUS,
      width: "10%",
    },
    {
      key: "activeStatusText",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ACTIVE,
      width: "5%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "10%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.FUEL} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onFuelEntry(params.row)}
            >
              <FuelIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.REPAIR_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onRepairEntry(params.row)}
            >
              <RepairIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.PAYMENT_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onPaymentEntry(params.row)}
            >
              <PaymentIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.RECEIPT_ICON} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onReceiptEntry(params.row)}
            >
              <ReceiptIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "options",
      name: LABELS.PRINT,
      width: 150,
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.PRINT_GUJARATI} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onPrintTrip(params.row, "Gujarati")}
            >
              <IconPrint />
            </IconButton>
          </Tooltip>
          <Tooltip title={LABELS.PRINT_HINDI} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onPrintTrip(params.row, "Hindi")}
            >
              <IconPrint />
            </IconButton>
          </Tooltip>{" "}
          <Tooltip title={LABELS.PRINT_ENGLISH} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onPrintTrip(params.row, "English")}
            >
              <IconPrint />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const onPrintTrip = (row: any, lang) => {
    const args = {
      id: row.id,
      lang: lang,
    };
    ApiIndentHandler.getTripPrint(args)
      .then((res) => {
        if (res) {
          let base64 = "data:application/pdf;base64, " + res;
          console.log("base64:", base64);
          fetch(base64).then((r) => {
            r.blob().then((data) => {
              let objUrl = window.URL.createObjectURL(data);
              window.open(objUrl, "_blank");
              window.URL.revokeObjectURL(objUrl);
            });
          });
        } else {
          COMMON_JS.showNotify(
            props,
            NOTIFY.ERROR,
            "Print Pay Slip Not Found..!"
          );
        }
      })
      .catch((err) => {
        COMMON_JS.showNotify(
          props,
          NOTIFY.ERROR,
          "Print Pay Slip Not Found..!"
        );
      });
  };

  const manageRecord = () => {
    const referenceNo = (
      document.getElementById("referenceNo") as HTMLInputElement
    ).value.trim();
    const brokerId = brokerIdRef.current.selectedValue.id;
    const customerId = customerIdRef.current.selectedValue.id;
    const vehicleId = vehicleIdRef.current.selectedValue.id;
    const driverId = driversRef.current.selectedValue.id;
    const driver2Id = drivers2Ref.current.selectedValue.id;
    const tempRangeId = tempIdRef.current
      ? tempIdRef.current.selectedValue.id
      : selectedRow.temprangeId;
    const loadingPoints = loadingPointIdRef.current.selectedValue.map(
      (p) => p.id
    );
    const unLoadingPoints = unloadingPointIdRef.current.selectedValue.map(
      (p) => p.id
    );
    const ldDate = (
      document.getElementById("ldDate") as HTMLInputElement
    ).value.trim();
    const indReceiptDate = (
      document.getElementById("indReceiptDate") as HTMLInputElement
    ).value.trim();
    const grossWt = (
      document.getElementById("grossWt") as HTMLInputElement
    ).value.trim();
    const tareWt = (
      document.getElementById("tareWt") as HTMLInputElement
    ).value.trim();
    const weight = (
      document.getElementById("weight") as HTMLInputElement
    ).value.trim();
    const product = (
      document.getElementById("product") as HTMLInputElement
    ).value.trim();
    const totCrates = (
      document.getElementById("totCrates") as HTMLInputElement
    ).value.trim();
    const deliveredCrates = (
      document.getElementById("deliveredCrates") as HTMLInputElement
    ).value.trim();
    const freight = (
      document.getElementById("freight") as HTMLInputElement
    ).value.trim();
    const lrNumber = (
      document.getElementById("lrNumber") as HTMLInputElement
    ).value.trim();
    const odometerOpen = (
      document.getElementById("odometerOpen") as HTMLInputElement
    ).value.trim();
    const odometerClose = (
      document.getElementById("odometerClose") as HTMLInputElement
    ).value.trim();
    const indContact = (
      document.getElementById("indContact") as HTMLInputElement
    ).value.trim();

    let mode = document.querySelector(
      'input[name="indMode"]:checked'
    ) as HTMLInputElement;
    const indMode = mode ? mode.value : "";
    let tFreight = document.querySelector(
      'input[name="freightType"]:checked'
    ) as HTMLInputElement;
    const freightType = tFreight ? tFreight.value : "";
    let tripCat = document.querySelector(
      'input[name="ldType"]:checked'
    ) as HTMLInputElement;
    const ldType = tripCat ? tripCat.value : "";
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";
    const billDate = (
      document.getElementById("billDate") as HTMLInputElement
    ).value.trim();
    const billNumber = (
      document.getElementById("billNumber") as HTMLInputElement
    ).value.trim();

    let choice = document.querySelector(
      'input[id="roundTrip"]:checked'
    ) as HTMLInputElement;
    const roundTrip = choice ? choice.checked : false;

    let manifestDetails = {};
    if (PARCEL) {
      const manifest1 = (
        document.getElementById("manifest_1") as HTMLInputElement
      ).value.trim();
      const manifest_Weight1 = (
        document.getElementById("manifestWeight_1") as HTMLInputElement
      ).value.trim();
      const manifest2 = (
        document.getElementById("manifest_2") as HTMLInputElement
      ).value.trim();
      const manifest_Weight2 = (
        document.getElementById("manifestWeight_2") as HTMLInputElement
      ).value.trim();
      const manifest3 = (
        document.getElementById("manifest_3") as HTMLInputElement
      ).value.trim();
      const manifest_Weight3 = (
        document.getElementById("manifestWeight_3") as HTMLInputElement
      ).value.trim();
      const manifest4 = (
        document.getElementById("manifest_4") as HTMLInputElement
      ).value.trim();
      const manifest_Weight4 = (
        document.getElementById("manifestWeight_4") as HTMLInputElement
      ).value.trim();
      const manifest5 = (
        document.getElementById("manifest_5") as HTMLInputElement
      ).value.trim();
      const manifest_Weight5 = (
        document.getElementById("manifestWeight_5") as HTMLInputElement
      ).value.trim();
      manifestDetails = {
        manifest1: {
          refNumber: manifest1,
          weight: manifest_Weight1,
        },
        manifest2: {
          refNumber: manifest2,
          weight: manifest_Weight2,
        },
        manifest3: {
          refNumber: manifest3,
          weight: manifest_Weight3,
        },
        manifest4: {
          refNumber: manifest4,
          weight: manifest_Weight4,
        },
        manifest5: {
          refNumber: manifest5,
          weight: manifest_Weight5,
        },
      };
    }
    // Validations

    let errors = [];
    if (freight == "") {
      errors.push({
        id: "freight",
        msg:
          "<span class='bold'>" +
          LABELS.FRIGHT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!customerId) {
      errors.push({
        id: "customerId",
        msg:
          "<span class='bold'>" +
          LABELS.CUSTOMER +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (ldDate == "") {
      errors.push({
        id: "ldDate",
        msg:
          "<span class='bold'>" +
          LABELS.LOADING_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (loadingPoints == "") {
      errors.push({
        id: "loadingPoints",
        msg:
          "<span class='bold'>" +
          LABELS.LOADING_PT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (unLoadingPoints == "") {
      errors.push({
        id: "unLoadingPoints",
        msg:
          "<span class='bold'>" +
          LABELS.UNLOADING_PT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    // if (billDate == "") {
    //   errors.push({
    //     id: "billDate",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.BILL_DATE +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    // if (billNumber == "") {
    //   errors.push({
    //     id: "billNumber",
    //     msg:
    //       "<span class='bold'>" +
    //       LABELS.BILL_NO +
    //       "</span> " +
    //       WARNINGS.IS_A_REQUIRED_FIELD,
    //   });
    // }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      indentId: selectedRow.id || -1,
      activeStatus: selectBtnValue,
      referenceNo: referenceNo,
      ldDate: ldDate,
      customerId: customerId,
      freight: Number(freight),
      cashAdvance: 0,
      dieselAdvance: 0,
      sessionId: 1,
      status: vehicleId ? "ASSIGNED" : "CREATED",
      indentDetailsId: -1,
      podDispatchAddressId: 2,
      vehicleTypeAxleId: 2,
      vehicleTypeBodytypeId: 2,
      vehicleTypeMainId: 2,
      vehicleTypePassingTonId: 2,
      vehicleId: vehicleId || null,
      freightType: freightType,
      tempRangeId: tempRangeId || null,
      loadingPoints,
      unLoadingPoints,
      product: product || " ",
      indContact: indContact || " ",
      indMode: indMode || " ",
      indReceiptDate: indReceiptDate,
      grossWt: Number(grossWt),
      tareWt: Number(tareWt),
      weight: Number(weight),
      totCrates: Number(totCrates),
      deliveredCrates: Number(deliveredCrates),
      billAmount: "",
      odometerOpen: Number(odometerOpen),
      odometerClose: Number(odometerClose),
      brokerId,
      roundTrip: roundTrip.toString(),
      ldType,
      driverId,
      driver2Id,
      billDate,
      billNumber,
      lrNumber,
      manifestDetails,
    };
    setGetAllPoints(false);
    console.log("Args:", args);
    setIsSubmit(true);
    ApiIndentHandler.manageIndent(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const onFuelEntry = (row: any) => {
    setSelectedRow(row);
    setFuelEntryDialog(true);
  };
  const onRepairEntry = (row: any) => {
    setSelectedRow(row);
    setRepairEntryDialog(true);
  };
  const onPaymentEntry = (row: any) => {
    setSelectedRow(row);
    setPaymentEntryDialog(true);
  };

  const onReceiptEntry = (row: any) => {
    setSelectedRow(row);
    setReceiptEntryDialog(true);
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  const onCancel = () => {
    setGetAllPoints(false);
    setManageDialog(false);
    setMandatoryResults([]);
  };

  console.log("customers:", customers, selectedRow, selectedLoadPoints);

  let manifestDetails: any = {};
  if (selectedRow.manifestDetails) {
    manifestDetails = JSON.parse(selectedRow.manifestDetails);
  }

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TRIPS}</li>
        </ul>
        <h4>{TITLES.TRIPS}</h4>
        <p className="SubTitles">{SUB_TITLES.TRIPS}</p>
      </div>

      <div id="chartForm">
        <div
          className="formGroup"
          style={{
            display: "flex",
            marginTop: 5,
            marginBottom: 20,
          }}
        >
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {" "}
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.FROM_DATE}
            </label>
            <TxtBox
              id={"fromDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "lastmonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              marginRight: 15,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <label
              style={{
                fontWeight: "500",
                fontSize: 18,
                marginTop: 6,
                marginRight: 10,
              }}
            >
              {LABELS.TO_DATE}
            </label>
            <TxtBox
              id={"toDate"}
              type={"datetime-local"}
              defaultValue={DateFunctions.getDate(
                "thismonth",
                "to",
                FORMATS.SQL_DATE
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
            }}
          >
            <Btn text={LABELS.LOAD} onClick={getRows} />
          </div>
        </div>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.TRIPS}
            height={window.innerHeight * 0.7}
            cols={COLUMNS}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TRIPS}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.TRIP + " : " + selectedRow.indentNo
              : "Add New " + LABELS.TRIP
          }
          open={true}
          size={"lg"}
          onClose={() => {
            setGetAllPoints(false);
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          {selectedLoadPoints && selectedUnLoadPoints ? (
            <>
              <div className="flexColumn">
                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.FREIGHT_AND_INDENT_DETAILS}
                  </legend>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indContact"}
                        label={LABELS.INDENT_CONTACT}
                        defaultValue={selectedRow.indContact}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"indReceiptDate"}
                        label={LABELS.INDENT_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.indReceiptDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.indReceiptDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={isSubmit}
                      />
                    </div>{" "}
                    <div className="formGroup width30 red">
                      <TxtRow
                        id={"freight"}
                        label={LABELS.FRIGHT}
                        type={"number"}
                        required={true}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.freight).toString()
                            : ""
                        }
                        disabled={isSubmit}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"referenceNo"}
                        label={LABELS.BILLING_LOCATION}
                        defaultValue={selectedRow.referenceNo}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.FREIGHT_MODE}</label>
                      <RadioBtn
                        list={[
                          {
                            id: "freightTypeToPay",
                            value: "TOPAY",
                            label: LABELS.TO_PAY,
                            checked: selectedRow.id
                              ? selectedRow.freightType === "TOPAY"
                              : true,
                            disabled: false,
                          },
                          {
                            id: "freightTypePaid",
                            value: LABELS.PAID,
                            label: LABELS.PAID,
                            checked: selectedRow.id
                              ? selectedRow.freightType === "PAID"
                              : false,
                            disabled: false,
                          },
                          {
                            id: "freightTypeTbb",
                            value: LABELS.TBB,
                            label: LABELS.TBB,
                            checked: selectedRow.id
                              ? selectedRow.freightType === "TBB"
                              : false,
                            disabled: false,
                          },
                        ]}
                        row={true}
                        name={"freightType"}
                        disabled={isSubmit}
                      />
                    </div>
                    {REEFER ? (
                      <div className="formGroup width30">
                        <label>{LABELS.TEMP_RANGE}</label>
                        <AutoComplete
                          list={tempratures}
                          childRef={tempIdRef}
                          defaultValue={
                            selectedRow.temprangeId
                              ? {
                                  id: selectedRow.temprangeId,
                                  label: selectedRow.tempRangeName,
                                }
                              : null
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    ) : (
                      <div className="formGroup width30"></div>
                    )}
                  </div>
                  <div className="flexRowJustify">
                    {GOPAL_SNACKS ? (
                      <div className="formGroup width30">
                        <label>{LABELS.TRIP_CAT}</label>
                        <RadioBtn
                          list={[
                            {
                              id: "ldTypeOwn",
                              value: "OwnTrip",
                              label: LABELS.OWN_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "OwnTrip"
                                : true,
                              disabled: false,
                            },
                            {
                              id: "ldTypeRevenue",
                              value: "RevenueTrip",
                              label: LABELS.REVENUE_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "RevenueTrip"
                                : false,
                              disabled: false,
                            },
                            {
                              id: "ldTypeEmpty",
                              value: "EmptyTrip",
                              label: LABELS.EMPTY_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "EmptyTrip"
                                : false,
                              disabled: false,
                            },
                            {
                              id: "ldTypRm",
                              value: "RmTrip",
                              label: LABELS.RAW_MATERIAL_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "RmTrip"
                                : false,
                              disabled: false,
                            },
                          ]}
                          row={true}
                          name={"ldType"}
                          disabled={isSubmit}
                        />
                      </div>
                    ) : (
                      <div className="formGroup width30">
                        <label>{LABELS.TRIP_CAT}</label>
                        <RadioBtn
                          list={[
                            {
                              id: "ldTypeRevenue",
                              value: "RevenueTrip",
                              label: LABELS.REVENUE_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "RevenueTrip"
                                : true,
                              disabled: false,
                            },
                            {
                              id: "ldTypeEmpty",
                              value: "EmptyTrip",
                              label: LABELS.EMPTY_TRIP,
                              checked: selectedRow.id
                                ? selectedRow.ldType === "EmptyTrip"
                                : false,
                              disabled: false,
                            },
                          ]}
                          row={true}
                          name={"ldType"}
                          disabled={isSubmit}
                        />
                      </div>
                    )}

                    {GOPAL_SNACKS ? (
                      <div className="formGroup width30">
                        <label>{LABELS.INDENT_MODE}</label>
                        <RadioBtn
                          list={[
                            {
                              id: "indModeMobile",
                              value: "Mobile",
                              label: LABELS.MOBILE,
                              checked: selectedRow.id
                                ? selectedRow.indMode === "Mobile"
                                : true,
                              disabled: false,
                            },
                            {
                              id: "indModeEmail",
                              value: LABELS.SAP,
                              label: LABELS.SAP,
                              checked: selectedRow.id
                                ? selectedRow.indMode === "SAP"
                                : false,
                              disabled: false,
                            },
                          ]}
                          row={true}
                          name={"indMode"}
                          disabled={isSubmit}
                        />
                      </div>
                    ) : (
                      <div className="formGroup width30">
                        <label>{LABELS.INDENT_MODE}</label>
                        <RadioBtn
                          list={[
                            {
                              id: "indModeMobile",
                              value: "Market",
                              label: LABELS.MARKET,
                              checked: selectedRow.id
                                ? selectedRow.indMode === "Market"
                                : true,
                              disabled: false,
                            },
                            {
                              id: "indModePhone",
                              value: "Company",
                              label: LABELS.COMPANY,
                              checked: selectedRow.id
                                ? selectedRow.indMode === "Company"
                                : false,
                              disabled: false,
                            },
                          ]}
                          row={true}
                          name={"indMode"}
                          disabled={isSubmit}
                        />
                      </div>
                    )}

                    <div
                      className="formGroup width30"
                      style={{ paddingTop: "1rem" }}
                    >
                      <ChkBox
                        id="roundTrip"
                        text={LABELS.ROUND_TRIP}
                        style={{ fontWeight: "600" }}
                        checked={
                          selectedRow.id
                            ? selectedRow.roundTrip === true
                            : false
                        }
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.INITIAL_TRIP_DATA}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"lrNumber"}
                        label={LABELS.LR_NUMBER_ORDER_NUMBER}
                        type={"text"}
                        defaultValue={selectedRow.lrNumber}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.VEHICLE_NO}</label>
                      <AutoComplete
                        list={vehicles}
                        childRef={vehicleIdRef}
                        defaultValue={
                          selectedRow.vehicleId
                            ? {
                                id: selectedRow.vehicleId,
                                label: selectedRow.vehicleNo,
                              }
                            : null
                        }
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_NAME}</label>
                      <AutoComplete
                        list={driverNames}
                        childRef={driversRef}
                        defaultValue={
                          selectedRow.driverId
                            ? {
                                id: selectedRow.driverId,
                                label: selectedRow.driverName,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        disabled={isSubmit}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <label>{LABELS.DRIVER_2_NAME}</label>
                      <AutoComplete
                        list={driverNames}
                        childRef={drivers2Ref}
                        defaultValue={
                          selectedRow.driver2Id
                            ? {
                                id: selectedRow.driver2Id,
                                label: selectedRow.driver2Name,
                              }
                            : null
                        }
                        onChange={(e, v) => {}}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30 red">
                      <label>
                        {LABELS.CUSTOMER}
                        {<span>{" *"}</span>}
                      </label>
                      <AutoComplete
                        list={customers}
                        childRef={customerIdRef}
                        defaultValue={
                          selectedRow.id
                            ? {
                                id: selectedRow.transporterId,
                                label: selectedRow.transporterName,
                              }
                            : null
                        }
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <label>{LABELS.BROKER}</label>
                      <AutoComplete
                        list={customers}
                        childRef={brokerIdRef}
                        defaultValue={
                          selectedRow.brokerId
                            ? {
                                id: selectedRow.brokerId,
                                label: selectedRow.brokerName,
                              }
                            : null
                        }
                        disabled={isSubmit}
                      />
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width30 red">
                      <TxtRow
                        id={"ldDate"}
                        label={LABELS.LOADING_DATE}
                        type={"datetime-local"}
                        required={true}
                        defaultValue={
                          selectedRow.ldDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.ldDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerOpen"}
                        label={LABELS.OPENING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerOpen}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.ROUTE_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <div className="justifySpaceBetween red">
                        <label
                          style={{ marginTop: "0.5rem", fontWeight: "500" }}
                        >
                          {LABELS.LOADING_PT}
                          {<span className="red">{" *"}</span>}
                        </label>
                        <Btn
                          text={
                            getAllPoints
                              ? LABELS.SHOW_LOADING_POINTS
                              : LABELS.SHOW_ALL_POINTS
                          }
                          bgColor={getAllPoints ? "#e9e9f8" : "#e9e9e9"}
                          color={"#3f3f3f"}
                          onClick={(prevGetAllPoints) => {
                            setGetAllPoints(
                              (prevGetAllPoints) => !prevGetAllPoints
                            );
                          }}
                        />
                      </div>
                      {selectedLoadPoints && (
                        <AutoComplete
                          id="multiple-limit-tags"
                          list={getAllPoints ? unLoadingPoints : loadingPoints}
                          childRef={loadingPointIdRef}
                          multiple={true}
                          defaultValue={
                            selectedRow.id ? selectedLoadPoints : []
                          }
                          disabled={isSubmit}
                          limit={3}
                        />
                        // </div>
                      )}
                    </div>
                    <div
                      className="formGroup width45 red"
                      style={{ paddingTop: "0.4rem" }}
                    >
                      <label>
                        {LABELS.UNLOADING_PT}
                        {<span>{" *"}</span>}
                      </label>
                      {selectedUnLoadPoints && (
                        <AutoComplete
                          list={unLoadingPoints}
                          childRef={unloadingPointIdRef}
                          multiple={true}
                          defaultValue={
                            selectedRow.id ? selectedUnLoadPoints : []
                          }
                          disabled={isSubmit}
                          limit={3}
                        />
                      )}
                    </div>
                  </div>
                  <div className="flexRowJustify">
                    <div className="formGroup width45">
                      <TxtRow
                        id={"product"}
                        label={LABELS.PRODUCT}
                        defaultValue={selectedRow.product}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width45">
                      <TxtRow
                        id={"totCrates"}
                        label={LABELS.ORDERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.totCrates}
                        disabled={isSubmit}
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.LOAD_WEIGHTS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"grossWt"}
                        label={LABELS.GROSS_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.grossWt).toString()
                            : ""
                        }
                        disabled={isSubmit}
                      />
                    </div>

                    <div className="formGroup width30">
                      <TxtRow
                        id={"tareWt"}
                        label={LABELS.TARE_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.tareWt).toString()
                            : ""
                        }
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"weight"}
                        label={LABELS.NET_WT}
                        type={"number"}
                        defaultValue={
                          selectedRow.id
                            ? Number(selectedRow.weight).toString()
                            : ""
                        }
                        disabled={isSubmit}
                      />
                    </div>
                  </div>

                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"billDate"}
                        label={LABELS.BILL_DATE}
                        type={"datetime-local"}
                        defaultValue={
                          selectedRow.billDate
                            ? DateFunctions.getFormatedDate(
                                selectedRow.billDate,
                                FORMATS.SQL_DATE,
                                FORMATS.SQL_DATE
                              )
                            : DateFunctions.getDate(
                                "now",
                                "from",
                                FORMATS.SQL_DATE
                              )
                        }
                        // required={true}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"billNumber"}
                        label={LABELS.BILL_NO}
                        type={"number"}
                        defaultValue={selectedRow.billNumber}
                        // required={true}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                {PARCEL && (
                  <fieldset className="formSection">
                    <legend className="formSectionLegend">
                      {LABELS.MANIFEST}
                    </legend>
                    <div className="flexRowJustify">
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_1}</label>
                        <TxtBox
                          id={"manifest_1"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest1
                              ? manifestDetails.manifest1.refNumber
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_WEIGHT_1}</label>
                        <TxtBox
                          id={"manifestWeight_1"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest1
                              ? manifestDetails.manifest1.weight
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    </div>
                    <div className="flexRowJustify">
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_2}</label>
                        <TxtBox
                          id={"manifest_2"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest2
                              ? manifestDetails.manifest2.refNumber
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_WEIGHT_2}</label>
                        <TxtBox
                          id={"manifestWeight_2"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest2
                              ? manifestDetails.manifest2.weight
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    </div>
                    <div className="flexRowJustify">
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_3}</label>
                        <TxtBox
                          id={"manifest_3"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest3
                              ? manifestDetails.manifest3.refNumber
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_WEIGHT_3}</label>
                        <TxtBox
                          id={"manifestWeight_3"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest3
                              ? manifestDetails.manifest3.weight
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    </div>
                    <div className="flexRowJustify">
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_4}</label>
                        <TxtBox
                          id={"manifest_4"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest4
                              ? manifestDetails.manifest4.refNumber
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_WEIGHT_4}</label>
                        <TxtBox
                          id={"manifestWeight_4"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest4
                              ? manifestDetails.manifest4.weight
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    </div>
                    <div className="flexRowJustify">
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_5}</label>
                        <TxtBox
                          id={"manifest_5"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest5
                              ? manifestDetails.manifest5.refNumber
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                      <div className="formGroup width45">
                        <label>{LABELS.MANIFEST_WEIGHT_5}</label>
                        <TxtBox
                          id={"manifestWeight_5"}
                          type={"text"}
                          defaultValue={
                            manifestDetails.manifest5
                              ? manifestDetails.manifest5.weight
                              : ""
                          }
                          disabled={isSubmit}
                        />
                      </div>
                    </div>
                  </fieldset>
                )}

                <fieldset className="formSection">
                  <legend className="formSectionLegend">
                    {LABELS.DELIVERY_DETAILS}
                  </legend>
                  <div className="flexRowJustify">
                    <div className="formGroup width30">
                      <TxtRow
                        id={"deliveredCrates"}
                        label={LABELS.DELIVERED_QTY}
                        type={"number"}
                        defaultValue={selectedRow.deliveredCrates}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30">
                      <TxtRow
                        id={"odometerClose"}
                        label={LABELS.CLOSING_KM}
                        type={"number"}
                        defaultValue={selectedRow.odometerClose}
                        disabled={isSubmit}
                      />
                    </div>
                    <div className="formGroup width30"></div>
                  </div>
                </fieldset>

                <div
                  className="flexRowJustify"
                  style={{ alignItems: "center" }}
                >
                  <div
                    className="formGroup width30 red"
                    style={{ paddingLeft: "0.5rem" }}
                  >
                    <label>
                      {LABELS.ACTIVE_STATUS} {<span>*</span>}
                    </label>
                    <RadioBtn
                      list={[
                        {
                          id: "activeYes",
                          value: "true",
                          label: LABELS.ACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === true
                            : true,
                          disabled: false,
                        },
                        {
                          id: "activeNo",
                          value: "false",
                          label: LABELS.INACTIVE,
                          checked: selectedRow.id
                            ? selectedRow.activeStatus === false
                            : false,
                          disabled: false,
                        },
                      ]}
                      row={true}
                      name={"activeStatus"}
                      disabled={isSubmit}
                    />
                  </div>

                  <div className="formGroup width30"></div>
                </div>
              </div>

              {/* mandatoryResults */}
              {mandatoryResults.length > 0 && (
                <div className="mandatoryBox">
                  <ul>
                    {mandatoryResults.map((m) => {
                      return (
                        <li>
                          <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}

              <div className="formGroup submitBtnWrapper">
                <div className="flexbtnjustify">
                  <Btn
                    text={LABELS.CANCEL}
                    bgColor={COLORS.RELOAD_EXPORT}
                    color={COLORS.RELOAD_EXPORT_TEXT}
                    // loading={isSubmit}
                    onClick={onCancel}
                  />
                  <Btn
                    text={LABELS.SAVE}
                    loading={isSubmit}
                    onClick={manageRecord}
                    bgColor={COLORS.SAVE_GREEN}
                  />
                </div>
              </div>
            </>
          ) : (
            <div className="flexCenter" style={{ height: 500 }}>
              <Loader />
            </div>
          )}
        </UiDialog>
      )}

      {fuelEntryDialog && (
        <FuelForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setFuelEntryDialog(val);
          }}
        />
      )}

      {repairtEntryDialog && (
        <RepairForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setRepairEntryDialog(val);
          }}
        />
      )}

      {paymentEntryDialog && (
        <TripPaymentForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setPaymentEntryDialog(val);
          }}
        />
      )}

      {receiptEntryDialog && (
        <TripReceiptForm
          defaultValues={selectedRow}
          selectedRow={{}}
          setSelectedRow={setSelectedRow}
          reloadGrid={reloadGrid}
          setManageDialog={(val) => {
            setReceiptEntryDialog(val);
          }}
        />
      )}
    </React.Fragment>
  );
};

export default withSnackbar(Trips);
